import React, { useEffect, useState } from "react";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setIsVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σου. Με τη
        συνέχιση της περιήγησης, αποδέχεσαι τη χρήση cookies.
      </p>
      <button onClick={handleAccept}>Αποδοχή</button>
    </div>
  );
};

export default CookieBanner;
